import React from 'react';
const Hero = () => {
  return <section className="w-full py-16 px-6 md:px-12 lg:px-24 flex flex-col md:flex-row items-center justify-between gap-12" data-id="element-72">
      <div className="w-full md:w-1/2 flex flex-col space-y-6" data-id="element-73">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#C17A47]" data-id="element-74">
          20 Cenas Listas en 15 Minutos ✨
        </h1>
        <h2 className="text-xl md:text-2xl font-medium text-[#6B5A45]" data-id="element-75">
          Recetas sin horno para mamás ocupadas
        </h2>
        <p className="text-lg text-[#6B5A45]" data-id="element-76">
          No es que no sepas cocinar. Es que ya no te queda tiempo ni energía.
        </p>
        <p className="text-lg text-[#6B5A45]" data-id="element-77">
          Y aun así, todos los días, alguien te mira con hambre y la misma
          pregunta: "¿Qué hay de cenar, mamá?"
        </p>
        <button className="w-full md:w-fit px-8 py-4 bg-[#C17A47] text-white text-lg font-bold rounded-md hover:bg-[#A05A27] transition-all shadow-lg" data-id="element-78">
          QUIERO MIS 20 CENAS EXPRESS
        </button>
      </div>
      <div className="w-full md:w-1/2 flex justify-center" data-id="element-79">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x5hNN8tDF6N1EcabuCAPdx/Generated_Image_September_11%2C_2025_-_3_18PM.png" alt="Libro de recetas 20 Cenas Listas en 15 Minutos" className="w-full max-w-md rounded-lg shadow-xl" data-id="element-80" />
      </div>
    </section>;
};
export default Hero;